import type { PrefferedUnit } from '../types';
import { convertCentimetersToInches, convertInchesToCentimeters } from './inches';
import { convertKilogramsToPounds, convertPoundsToKilograms } from './pounds';

export type ImperialUnits = {
  units: { height: ImperialHeightUnit; label: string; weight: Unit };
} & Omit<Units, 'units'>;

export type Unit = {
  convertFromDefault: (value: number) => number;
  convertToDefault: (value: number) => number;
  format: (value: number) => string;
  label: string;
};

export type Units = {
  label: string;
  units: {
    height: Unit;
    label: string;
    weight: Unit;
  };
  value: PrefferedUnit;
};

type ImperialHeightUnit = {
  feet: {
    format: (feet: number) => string;
    label: string;
  };
  format: (feet: number, inches: number) => string;
  inches: {
    format: (inches: number) => string;
    label: string;
  };
} & Omit<Unit, 'format'>;

export const imperialUnits: ImperialUnits = {
  label: 'Imperial',
  units: {
    height: {
      convertFromDefault: convertCentimetersToInches,
      convertToDefault: convertInchesToCentimeters,
      feet: {
        format: (feet: number) => `${feet}’`,
        label: 'ft',
      },
      format: (feet: number, inches: number) => `${feet}’ ${inches}”`,

      inches: {
        format: (inches: number) => `${inches}”`,
        label: 'in',
      },
      label: 'in',
    },
    label: 'lb, in, yd, °F',
    weight: {
      convertFromDefault: convertKilogramsToPounds,
      convertToDefault: convertPoundsToKilograms,
      format: (lbs: number) => `${lbs} lbs`,
      label: 'lbs',
    },
  },
  value: 'imperial',
};
